/**
 * The viewport's first-run navigation hint: the controls for the pointer the
 * visitor has. A phone gets its gestures (TouchNavigator), a mouse its
 * buttons and keys (ViewportNavigator), as the two navigators map them.
 */

/** The main pointer, as the `pointer` media feature reports it. */
export type PointerKind = "fine" | "coarse";

export type NavHint = readonly [keys: string, action: string];

const MOUSE_HINTS: readonly NavHint[] = [
  ["RMB + WASD", "fly"],
  ["Alt + LMB", "orbit"],
  ["MMB", "pan"],
  ["F", "frame selection"],
  ["~", "console"],
];

const TOUCH_HINTS: readonly NavHint[] = [
  ["Drag", "orbit"],
  ["2 fingers", "pan"],
  ["Pinch", "zoom"],
  ["Double-tap", "frame"],
  ["Hold", "menu"],
  ["2-finger tap", "undo"],
];

export function navHints(pointer: PointerKind): readonly NavHint[] {
  return pointer === "coarse" ? TOUCH_HINTS : MOUSE_HINTS;
}
